// StudioPointMenu — a menu opened where the pointer is (a right-click on a
// card or on the empty canvas, pen "Studio – detail design" §4). The shared
// Menu, anchored to an invisible point at `at` (viewport pixels, inside the
// canvas). Open while shown; closing (a pick, Esc, a click outside) reports
// up. View state only.

export { StudioPointMenu };

import type { ReactNode } from "react";
import { Menu, type MenuItem } from "../Menu/Menu.js";
import type { Point } from "./studioLayout.js";

const StudioPointMenu = ({
    at,
    items,
    onClose,
}: {
    readonly at: Point;
    readonly items: readonly MenuItem[];
    readonly onClose: () => void;
}): ReactNode => (
    <Menu
        open
        onOpenChange={(open) => {
            if (!open) onClose();
        }}
        items={items}
        trigger={
            <span
                className="bilda-studio__point"
                style={{ left: at.x, top: at.y }}
                aria-hidden="true"
            />
        }
    />
);
